import React from 'react';
import { Carousel } from 'react-bootstrap';
import styled from 'styled-components';
import samplephoto1 from '../assets/samplephoto1.jpg';
import samplephoto2 from '../assets/samplephoto2.jpg';
import samplephoto3 from '../assets/samplephoto3.jpg';

const Styles = styled.div` 
.carousel-bg { 
    background: #50a3a2;
    background: -webkit-linear-gradient(top left, #cfc7c0 0%, #b1a8a0 100%);
    background: -moz-linear-gradient(top left, #cfc7c0 0%, #b1a8a0 100%);
    background: -o-linear-gradient(top left, #cfc7c0 0%, #b1a8a0 100%);
    background: linear-gradient(to bottom right, #cfc7c0 0%, #b1a8a0 100%);
   
 }

.wrapperbox{
    background: #50a3a2;
    background: -webkit-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: -moz-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: -o-linear-gradient(top left, #d9d2cc 0%, #b1a8a0 100%);
    background: linear-gradient(to bottom right, #d9d2cc 0%, #b1a8a0 100%);
   
	// top: 50%;
	// left: 0;
	// width: 100%;
	// height: 400px;
	// overflow: hidden;
    
	// margin-top: -200px;
    // position: absolute;

    // z-index:1;

}

.containerbox{
	max-width: 600px;
	margin: 0 auto;
	padding: 80px 0;
	height: 300px;
	text-align: center;
}


.bg-bubbles{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	
	z-index: 0;
	
	.objecticon{
		&:nth-child(1){
			left: 10%;
            
			width: 80px;
			height: 80px;
			
		}
		
		&:nth-child(2){
			left: 20%;
			
			width: 80px;
			height: 80px;
			
			animation-delay: 2s;
			animation-duration: 17s;
		}
		
		&:nth-child(3){
			left: 25%;
			animation-delay: 4s;
		}
		
		&:nth-child(4){
			left: 40%;
			width: 60px;
			height: 60px;
			
			animation-duration: 22s;
			
			background-color: fade(white, 25%);
		}
		
		&:nth-child(5){
			left: 70%;
		}
		
		&:nth-child(6){
			left: 80%;
			width: 120px;
			height: 120px;
			
			animation-delay: 3s;
			background-color: fade(white, 20%);
		}
		
		&:nth-child(7){
			left: 32%;
			width: 160px;
			height: 160px;
			
			animation-delay: 7s;
		}
		
		&:nth-child(8){
			left: 55%;
			width: 20px;
			height: 20px;
			
			animation-delay: 15s;
			animation-duration: 40s;
		}
		
		&:nth-child(9){
			left: 25%;
			width: 10px;
			height: 10px;
			
			animation-delay: 2s;
			animation-duration: 40s;
			background-color: fade(white, 30%);
		}
		
		&:nth-child(10){
			left: 90%;
			width: 160px;
			height: 160px;

			animation-delay: 11s;
		}
	}
}

.objecticon {
    top:440px;    
       
    display:block;
    position:absolute;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: white;   
    opacity:23%;

    -webkit-animation: square 25s infinite;
    animation: square 25s infinite;
    -webkit-transition-timing-function: linear;
    transition-timing-function: linear;
}


@-webkit-keyframes square {
    0%   { transform: translateY(0); }
    100% { transform: translateY(-700px) rotate(600deg); }
  }
  @keyframes square {
    0%   { transform: translateY(0); }
    100% { transform: translateY(-700px) rotate(600deg); }
  }
  


.carousel-item {
    //adjust accordingly
    height:300px;  
}

h5 {
    color:#3b3b3b;
}

p {
    color:#3b3b3b;
}


`;

const CarouselBar = () => {

    return (
        <Styles>
            <div className="animate__animated animate__fadeIn animate__delay-800ms">
                <div className="row carousel-bg">

                    {/* DO NOT TOUCH OBJECT BANNERS */}
                    <div className="wrapperbox">
                        <ul className="bg-bubbles">
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            {/* additional */}
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                            <li className="objecticon"></li>
                        </ul>
                    </div>

                    <div className="container">
                        <Carousel className="slide carousel-fade">
                            <Carousel.Item >
                                <img
                                    // className="d-block h-100"
                                    src={samplephoto1}
                                    alt="First slide"
                                />
                                <Carousel.Caption>
                                    <h5>Pick up health tips at community classes</h5>
                                    <p>Tan Tock Seng Hospital coaches inculcate healthier habits, diabetes prevention and more in wellness programmes</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={samplephoto2}
                                    alt="Second slide"
                                />
                                <Carousel.Caption>
                                    <h5>Medication Information</h5>
                                    <p>Search through our list by medication name or disease/condition.</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={samplephoto3}
                                    alt="Third slide"
                                />
                                <Carousel.Caption>
                                    <h5>Our Clinics and Services</h5>
                                    <p>Learn more about the services available at our clinics.</p>
                                </Carousel.Caption>
                            </Carousel.Item>
                        </Carousel>
                    </div>



                </div>
            </div>

        </Styles >
    );
};

export default CarouselBar;